import type React from "react";
import { ActivityIndicator, View } from "react-native";
import type { SpinnerProps } from "@xsolla/xui-primitives-core";

export const Spinner: React.FC<SpinnerProps> = ({
  color,
  size,
  role,
  "aria-label": ariaLabel,
  "aria-live": ariaLive,
  testID,
}) => {
  return (
    <View
      accessible={true}
      accessibilityRole={role === "status" ? "none" : undefined}
      accessibilityLabel={ariaLabel}
      accessibilityLiveRegion={
        ariaLive === "polite"
          ? "polite"
          : ariaLive === "assertive"
            ? "assertive"
            : "none"
      }
      testID={testID}
    >
      <ActivityIndicator
        color={color}
        size={typeof size === "number" ? size : "small"}
      />
    </View>
  );
};

Spinner.displayName = "Spinner";
